import { render } from "./tomorrowword.vue?vue&type=template&id=3c6ace92&scoped=true"
import script from "./tomorrowword.vue?vue&type=script&lang=js"
export * from "./tomorrowword.vue?vue&type=script&lang=js"

import "./tomorrowword.vue?vue&type=style&index=0&id=3c6ace92&scoped=true&lang=css"

import exportComponent from "D:\\startup\\gtdhtml5\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c6ace92"]])

export default __exports__